// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
// import Loadable from 'react-loadable';
import { AppRouteType } from '__utils/type';
import PremiumServices from 'views/premium-services';
import PremiumServiceDetails from 'views/premium-services/premium-service-details';
import KycDetails from 'views/investor-profile/kyc-details'
import NotFound from 'views/not-found';
import PersonalDetails from 'views/investor-profile/personal-details'
import BankDetails from 'views/investor-profile/bank-details';
import OccupationDetails from 'views/investor-profile/occupation-Details';
import NeftPayment from 'views/payment-flow/neft-payment';
import SignzyPopulate from 'views/investor-profile/signzy-populate';
import ChequePayment from 'views/payment-flow/cheque-payment';
import TransactionError from 'views/transaction-error';
import RiskProfileResults from 'views/investor-profile/risk-profile/risk-profile-results';
import RiskProfile from 'views/investor-profile/risk-profile';
import OrderConfirmPayment from 'views/payment-flow/order-summary';
import Challan from 'views/payment-flow/challan';
import Layout from 'components/layout';
import { isFlowTypeCheckout } from '__utils/common-utils';
import ProfileDashboardLayout from 'components/profile-dashboard-layout';
import { HeaderIcons } from 'constants/header-config';
import ThankYou from 'views/thank-you';
import PaymentFailure from 'components/payment-mode/payment-failure';
import AwaitingForUpi from 'views/payment-flow/order-summary/upi-payment-awaiting';
import Mandates from 'views/mandates';
import SetupMandate from 'views/mandates/setup-mandate';
import CreateNewStp from 'views/stp-swp/stps/create-new-stp';
import StpDetails from 'views/stp-swp/stps';
import NFOsFunds from 'views/nfos';
import SipCalculator from 'views/calculators/investment-calculators/sip-calculator';
import GoalAmountCalculator from 'views/calculators/investment-calculators/goal-amount-calculator';
import Home from 'views/home';
import Portfolio from 'views/portfolio';
import PortfolioDetails from 'views/portfolio/portfolio-details';
import SearchFundsResult from 'views/search';
import SearchPanel from 'views/search/search-panel';
import PrivacyPolicy from 'views/privacypolicy';
import TermsConditions from 'views/terms-conditions';
import ProfileDetails from 'views/investor-profile/profile-details';
import PersonalAccountInfo from 'views/investor-profile/profile-details/personal-account-info';
import BankAccountInfo from 'views/investor-profile/profile-details/bank-info';
import EmployementInfo from 'views/investor-profile/profile-details/employement-info';
import NomineeInfo from 'views/investor-profile/profile-details/nominee-info';

// const AsyncAbout = Loadable({
//     loader: () => import(/* webpackChunkName: "about" */ './views/about'),
//     loading: () => <div>Loading...</div>,
// });

// export interface Route {
// 	path?: string;

// 	component?:  // eslint-disable-next-line @typescript-eslint/no-explicit-any
// 		| React.ComponentType<RouteComponentProps<any>>
// 		// eslint-disable-next-line @typescript-eslint/no-explicit-any
// 		| React.ComponentType<any>;
// 	exact?: boolean;
// 	children?: Route[];
// 	redirect?: {
// 		pathname: string;
// 	};
// }

/**
 * Spreads out routes for V4 router to have a flat hierarchy
 * @param routesData nested routes
 * @param parent recursion path variable to spread path
 * @returns flatRoutes
 */

export const spreadRoutes = (
	routesData: AppRouteType[],
	parent = ''
): AppRouteType[] => {
	parent = parent === '/' ? '' : parent;
	return routesData.reduce((acc: AppRouteType[], route: AppRouteType) => {
		return [
			...acc,
			{ ...route, path: parent + route.path },
			...(route.children
				? spreadRoutes(route.children, parent + route.path)
				: [])
		];
	}, []);
};

export const routes: AppRouteType[] = [
	{
		key: 1,
		path: '/',
        component: Home,
        exact: true,
		layout: Layout,
		headerIconSet: HeaderIcons.homeHeader 
	},
	{
		key: 2,
		path: '/premium-services',
		component: PremiumServices,
		exact: true,
		layout: Layout,
		headerIconSet: HeaderIcons.cartNcall
	},
	{
		key: 3,
		path: '/premium-service-details/:route',
		component: PremiumServiceDetails,
		exact: true,
		layout: Layout,
		// headerIconSet: HeaderIcons.cartNcall

	},
	{
		key: 4,
		path: '/profile/kyc-details',
		component: KycDetails,
		exact: true,
		layout: Layout,
		headerIconSet: HeaderIcons.cartNcall
	},
	{
		key: 5,
		path: '/profile/personal-details',
		component: PersonalDetails,
		exact: true,
		layout: Layout,
		headerIconSet: HeaderIcons.cartNcall
	},
	{
		key: 6,
		path: '/profile/bank-details',
		component: BankDetails,
		exact: true,
		layout: Layout,
		headerIconSet: HeaderIcons.cartNcall
	},
	{
		key: 7,
		path: '/profile/occupation-nominee-details',
		component: OccupationDetails,
		exact: true,
		layout: Layout,
		headerIconSet: HeaderIcons.cartNcall
	},
	{
        key: 8,
        path: '/profile/risk-profile',
        component: RiskProfile,
        exact: true,
		layout: isFlowTypeCheckout() ? Layout : ProfileDashboardLayout,
		headerIconSet: isFlowTypeCheckout() ? HeaderIcons.cartNcall : HeaderIcons.visibleLogo
    },
    {
        key: 9,
        path: '/profile/risk-profile-result',
        component: RiskProfileResults,
		exact: true,
		layout: isFlowTypeCheckout() ? Layout : ProfileDashboardLayout,
		headerIconSet: isFlowTypeCheckout() ? HeaderIcons.cartNcall : HeaderIcons.visibleLogo		
	},
	{
		key: 10,
		path: '/signzy-callback',
		component: SignzyPopulate,
		exact: true,
		layout: Layout,
		headerIconSet: HeaderIcons.cartNcall
	},
	{
        key: 11,
        path: '/transaction-error',
        component: TransactionError,
        exact: true,
		layout: Layout,
		headerIconSet: HeaderIcons.hideRedToMintpro
    },		
	{
        key: 12,
        path: '/order-summary',
        component: OrderConfirmPayment,
        exact: true,
		layout: Layout,
		headerIconSet: HeaderIcons.showBackToHomeCTA
    },
	{
        key: 13,
        path: '/challan',
        component: Challan,
        exact: true,
		layout: Layout,
		headerIconSet: HeaderIcons.showBackToHomeCTA
    },
	{
        key: 14,
        path: '/cheque-payment',
        component: ChequePayment,
        exact: true,
		layout: Layout,
		headerIconSet: HeaderIcons.showBackToHomeCTA
    },
	{
        key: 15,
        path: '/upi-payment',
		layout: Layout,
        component: AwaitingForUpi,
        exact: true,
		headerIconSet: HeaderIcons.showBackToHomeCTA

    },		
	{
        key: 16,
        path: '/neft-payment',
        component: NeftPayment,
        exact: true,
		layout: Layout,
		headerIconSet: HeaderIcons.showBackToHomeCTA
    },
    {
        key: 17,
        path: '/transaction-error',
		layout: Layout,
        component: TransactionError,
        exact: true
    },
    {
        key: 18,
        path: '/thank-you',
		layout: Layout,
        component: ThankYou,
        exact: true,
				headerIconSet: HeaderIcons.cartNcall
    },
    {
        key: 19,
        path: '/payment-error',
		layout: Layout,
        component: PaymentFailure,
		headerIconSet: HeaderIcons.cartNcall
    },	
    {
        key: 20,
        path: '/profile/stps',
        component: StpDetails,
		exact: true,
		layout: ProfileDashboardLayout,
		headerIconSet: HeaderIcons.cartNcall
    },		
    {
        key: 21,
        path: '/profile/stps/create-new-stp',
        component: CreateNewStp,
		exact: true,
		layout: ProfileDashboardLayout, 
		headerIconSet: HeaderIcons.cartNcall

    },	
	{
        key: 22,
        path: '/profile/mandates',
        component: Mandates,
        exact: true,
		layout: ProfileDashboardLayout,
		headerIconSet: HeaderIcons.cartNcall 
    },
	{
        key: 23,
        path: '/nfos',
        component: NFOsFunds,
		layout: Layout,
        exact: true,
		headerIconSet:  HeaderIcons.showAllIcon
    },
    {
        key: 24,
        path: '/profile/mandates/setup-mandate',
        component: SetupMandate,
        exact: true,
		layout: isFlowTypeCheckout() ? Layout : ProfileDashboardLayout,
		headerIconSet: HeaderIcons.cartNcall 
    },		
    {
        key: 25,
        path: '/profile/mandates/setup-mandate',
        component: SetupMandate,
        exact: true,
		layout: isFlowTypeCheckout() ? Layout : ProfileDashboardLayout,
		headerIconSet: HeaderIcons.cartNcall 
    }, 
	{
        key: 26,
        path: '/sip-calculator',
        component: SipCalculator,
        exact: true,
		layout: Layout,
		headerIconSet: HeaderIcons.calculatorHeader 
    },	
	{
        key: 27,
        path: '/goal-amount-calculator',
        component: GoalAmountCalculator,
        exact: true,
		layout: Layout,
		headerIconSet: HeaderIcons.calculatorHeader 
    },
	{
        key: 28,
        path: '/profile/portfolio',
        component: Portfolio,
		exact: true,
		layout: ProfileDashboardLayout, 
		headerIconSet: HeaderIcons.cartNcall
    },	
	{
        key: 29,
        path: '/portfolio-details',
        component: PortfolioDetails,
		exact: true,
		layout: Layout, 
		headerIconSet: HeaderIcons.cartNcall
    },	
	{
        key: 30,
        path: '/home',
        component: Home,
        exact: true,
		layout: Layout,
		headerIconSet: HeaderIcons.homeHeader 
    },
	{
        key: 31,
        path: '/search',
        component: SearchFundsResult,
        exact: true,
        layout: Layout, 
        headerIconSet: HeaderIcons.showOnlyBackButton
    },
    {
        key: 32,
        path: '/search-panel',
        component: SearchPanel,
        exact: true,
        layout: Layout, 
        headerIconSet: HeaderIcons.cartNcall
    },
	{
        key: 33,
        path: '/privacy-policy',
        component: PrivacyPolicy,
        exact: true,
        layout: Layout, 
        headerIconSet: HeaderIcons.showAllIcon
    },
	{
        key: 34,
        path: '/terms-conditions',
        component: TermsConditions,
        exact: true,
        layout: Layout, 
        headerIconSet: HeaderIcons.showAllIcon
    },	
	{
        key: 38,
        path: '/profile',
        component: ProfileDetails,
        exact: true,
        layout: ProfileDashboardLayout, 
        headerIconSet: HeaderIcons.showAllIcon
    },	
	{
        key: 39,
        path: '/profile/personal-info',
        component: PersonalAccountInfo,
        exact: true,
        layout: ProfileDashboardLayout, 
        headerIconSet: HeaderIcons.showAllIcon
    },	
	{
        key: 40,
        path: '/profile/bank-info',
        component: BankAccountInfo,
        exact: true,
        layout: ProfileDashboardLayout, 
        headerIconSet: HeaderIcons.showAllIcon
    },	
	{
        key: 41,
        path: '/profile/employment-info',
        component: EmployementInfo,
        exact: true,
        layout: ProfileDashboardLayout, 
        headerIconSet: HeaderIcons.showAllIcon
    },	
	{
        key: 42,
        path: '/profile/nominee-info',
        component: NomineeInfo,
        exact: true,
        layout: ProfileDashboardLayout, 
        headerIconSet: HeaderIcons.showAllIcon
    },	
	{
		key: 60,
		component: NotFound,
		path: '**',
	},
];

export const flatRoutes = spreadRoutes(routes);

export const getheaderIconSetForRoute = (path: string) => {
	let filteredRoutes: AppRouteType[] = routes.filter(element => element.path?.includes(path));
	if (filteredRoutes.length > 0 && filteredRoutes[0].headerIconSet) {
		return filteredRoutes[0].headerIconSet;
	}
	return null;
}